import { react2angular } from 'react2angular';

import { SignUp } from '../signup/SignUp';
import kerbinCoreModule from './kerbin-core';

const ngModule = angular.module('kerbin-signup', [
    kerbinCoreModule,
  ])

  .config(function($stateProvider) {
    $stateProvider

      .state('signup', {
        route: 'signup',
        views: {
          page: {
            template: '<kerbin-sign-up />',
          },
        },
      })

      ;
  })

  .config(function(munSessionProvider) {
    // Disable the normal session machinery to prevent page refreshes caused by
    // the cookie watchers
    munSessionProvider.configure(null, /* @ngInject */ function($q) {
      return {
        refresh: function() {
          // Simulate a 401
          return $q.reject({status: 401});
        },
      };
    });
  })

  .run(function($state) {
    $state.goto('signup');
  })

  .component('kerbinSignUp', react2angular(SignUp))

  ;

export default ngModule.name;
